export const PREFERED_COUNTRIES = ['gr', 'se', 'no'];
